import React, {Component} from 'react'
import Button from "reactstrap/es/Button"
import BulkChangeStatusModal from './BulkChangeStatusModal'

class BulkChangeStatus extends Component{
    state = {
        isOpen: false,
    }

    _handleToggleModal = () => {
        const {resetBulkAll, reloadItems} = this.props
        const {isOpen} = this.state

        this.setState({
            isOpen: !isOpen
        })

        if(isOpen) {
            resetBulkAll()
            reloadItems()
        }
    }

    render() {
        const {isOpen} = this.state

        return (
            <div>
                <Button color="link" onClick={this._handleToggleModal} className="mr-1">Change status</Button>
                {isOpen && (
                    <BulkChangeStatusModal
                        {...this.props}
                        isOpen={isOpen}
                        handleToggleModal={this._handleToggleModal}
                    />
                )}
            </div>
        );
    }

}

export default BulkChangeStatus